import { defineMessages } from 'react-intl-next';

const messagesBase = defineMessages({
	createTemplate: {
		id: 'snippets.createTemplate',
		defaultMessage: 'Create template',
		description: 'Label for the create template button in the contextual toolbar',
	},
	createTemplateLozenge: {
		id: 'snippets.createTemplateLozenge',
		defaultMessage: 'New',
		description: 'Lozenge label for the create template button in the contextual toolbar',
	},
	createTemplateModalTitle: {
		id: 'snippets.createTemplateModalTitle',
		defaultMessage: 'Create template',
		description: 'Title for the create template modal',
	},
	createTemplateModalDescription: {
		id: 'snippets.createTemplateModalDescription',
		defaultMessage: 'Save content and easily reuse it through / menu.',
		description: 'Description for the create template modal',
	},
	createTemplateModalNamePlaceholder: {
		id: 'snippets.createTemplateModalNamePlaceholder',
		defaultMessage: 'Enter template name',
		description: 'Placeholder for the template name input in the create template modal',
	},
	createTemplateModalNameLabel: {
		id: 'snippets.createTemplateModalNameLabel',
		defaultMessage: 'Name',
		description: 'Name label for the create template modal',
	},
	createTemplateModalCancelButton: {
		id: 'snippets.createTemplateModalCancelButton',
		defaultMessage: 'Cancel',
		description: 'Cancel button text for the create template modal',
	},
	createTemplateModalCreateButton: {
		id: 'snippets.createTemplateModalCreateButton',
		defaultMessage: 'Create',
		description: 'Create button text for the create template modal',
	},
	snippetBy: {
		id: 'snippets.quick-insert.by',
		defaultMessage: 'by {name}',
		description: 'Description text showing who created the snippet, with the creator name',
	},
});

export const messages = messagesBase;
